<template>
  <div class="greetings">
    <HeroBanner
        :background-image="bannerImage"
        title="대표 인사말"
        sub-title="전문성을 바탕으로 한 최고의 보청기전문기업, <br>다비치 히어링 보청기입니다."
    />

    <div class="greetings-content">
      <!-- Section 1: 차별화된 경쟁력으로 보청기전문기업 브랜드로 성장 -->
      <div class="greeting-section">
        <div class="text-container">
          <h2 class="main-title">차별화된 경쟁력으로<br>보청기전문기업 브랜드로 성장</h2>
          <p class="section-text">
            다비치 히어링 보청기는 고객이 전국 어느 매장에서나 동일한 서비스를 제공받을 수 있도록 다비치 전략 정책을 담은 서비스와 절차를 모두 표준화 및 시스템화 했으며, 제조사 직거래 유통 방식으로 좋은 품질의 보청기를 정액정찰제로 제공합니다.<br>이로서 120여개의 대형 체인망을 갖추며, 국민에게 신뢰받는 보청기 브랜드로 자리매김했습니다.
          </p>
        </div>
        <div class="greeting-image">
          <img :src="contentImage01" alt="다비치 히어링 매장" />
        </div>
      </div>

      <!-- Section 2: 글로벌 기업으로 도약 -->
      <div class="greeting-section">
        <div class="text-container">
          <h2 class="sub-title">글로벌 기업으로 도약</h2>
          <p class="section-text">
            다비치 히어링 보청기는 더 큰 도약을 이루고자 합니다.<br>중국 시장을 비롯한 아시아 및 전 세계의 1,000여개의 다비치 체인망을 구축해 전 세계에게 'Light Up Your Life' 비전으로 건강한 시야, 청력을 제공하고 명실상부한 글로벌 그룹으로 성장하겠습니다.
          </p>
        </div>
        <div class="greeting-image">
          <img :src="contentImage02" alt="글로벌 기업" />
        </div>
      </div>

      <!-- Section 3: 맑은 세상, 인류를 행복하게 -->
      <div class="greeting-section no-image">
        <div class="text-container">
          <h2 class="sub-title">맑은 세상, 인류를 행복하게</h2>
          <p class="section-text">
            또한 다비치 히어링 보청기는 온 세상을 맑고 밝게 다 비추는 마음으로 소외되고 어려운 생활을 하는 이웃에게 사회적 책임을 다하려고 합니다.<br>판매 수익의 일부를 기부하고 봉사활동을 통해 청력 검사 및 보청기 체험을 제공하는 등 다양한 방법으로 지원하여 더 나은 사회를 만들기 위해 기여하겠습니다.
          </p>
        </div>
      </div>

      <!-- Section 4: 이미지 -->
      <div class="greeting-image-only">
        <img :src="contentImage03" alt="다비치 히어링 보청기" />
      </div>

      <!-- Section 5: 마무리 인사 -->
      <div class="greeting-closing">
        <p class="section-text">
          앞으로 다비치 히어링 보청기는 다비치의 브랜드 가치를 제고하기 위해 노력해 나가겠습니다.<br>신성장동력을 발굴하고 지속 가능한 성장을 위해 시대에 부응하는 혁신에 앞장서며<br>모든 기업 활동에서 다비치다운 길을 걸으며 고객과 함께하겠습니다.
        </p>
        <p class="closing-text">
          여러분들의 많은 관심과 사랑을 부탁드립니다.<br>감사합니다.
        </p>
        <p class="signature">대표 김인규, 김봉건</p>
      </div>
    </div>
  </div>
</template>

<script>
import HeroBanner from "@/components/HeroBanner.vue";
import bannerBg from '@/assets/images/heros/01-top-img.png';
import contentImage01 from '@/assets/images/banners/01_content_01.png';
import contentImage02 from '@/assets/images/banners/01_content_02.png';
import contentImage03 from '@/assets/images/banners/01_content_03.png';

export default {
  name: 'Greetings',
  components: {
    HeroBanner
  },
  data() {
    return {
      bannerImage: [bannerBg],
      contentImage01: contentImage01,
      contentImage02: contentImage02,
      contentImage03: contentImage03,
    };
  },
};
</script>


<style scoped lang="scss">

.greetings {
  .greetings-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    max-width: 500px;
    margin: 0 auto;
    padding: 56px 0 0;
    background: #FFFFFF;
    gap: 40px;

    .greeting-section {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      padding: 0 0 5.58px;
      gap: 32px;

      &.no-image {
        gap: 0;
      }

      .text-container {
        padding: 0 36px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        max-width: 100%;
        gap: 24px;

        .sub-title {
          font-family: 'Noto Sans KR', sans-serif;
          font-weight: 700;
          font-size: 24px;
          line-height: 40px;
          letter-spacing: -0.05em;
          color: #222222;
          margin: 0;
        }

        .main-title {
          font-family: 'Noto Sans KR', sans-serif;
          font-weight: 700;
          font-size: 26px;
          line-height: 40px;
          letter-spacing: -1.11607px;
          color: #222222;
          margin: 0;
        }

        .section-text {
          font-family: font family/Font 1;
          font-weight: 400;
          font-size: 18px;
          leading-trim: NONE;
          line-height: 30px;
          letter-spacing: -0.5px;
          vertical-align: middle;
        }
      }

      .greeting-image {
        width: 100%;
        max-width: 500px;
        position: relative;
        overflow: hidden;

        img {
          width: 100%;
          height: auto;
          display: block;
          object-fit: cover;
        }
      }
    }

    .greeting-image-only {
      width: 100%;
      max-width: 500px;
      position: relative;
      overflow: hidden;
      align-self: stretch;

      img {
        width: 100%;
        height: auto;
        display: block;
        object-fit: cover;
      }
    }

    .greeting-closing {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      width: 425px;
      max-width: 100%;
      padding: 0 36px;
      gap: 22px;

      .section-text {
        font-family: 'Noto Sans KR', sans-serif;
        font-weight: 350;
        font-size: 18px;
        line-height: 30px;
        letter-spacing: -0.04em;
        color: #222222;
        margin: 0;
      }

      .closing-text {
        font-family: 'Noto Sans KR', sans-serif;
        font-weight: 350;
        font-size: 18px;
        line-height: 30px;
        letter-spacing: -0.04em;
        color: #222222;
        margin: 0;
      }

      .signature {
        font-family: 'Noto Sans KR', sans-serif;
        font-weight: 700;
        font-size: 18px;
        line-height: 22px;
        color: #222222;
        margin: 0;
      }
    }
  }

  // 모바일 768px - 좌우 20px 통일
  @media (max-width: 768px) {
    .greetings-content {
      padding: 40px 0 0;
      gap: 32px;

      .greeting-section {
        padding: 0 0 4px;
        gap: 24px;

        .text-container {
          width: 100%;
          gap: 20px;
          padding: 0 20px;  // 좌우 20px 통일

          .main-title {
            font-size: 20px;
            line-height: 32px;
          }

          .sub-title {
            font-size: 18px;
            line-height: 28px;
          }

          .section-text {
            font-size: 15px;
            line-height: 26px;
          }
        }
      }
      .greeting-closing {
        width: 100%;
        gap: 18px;
        padding: 0 20px;  // 좌우 20px 통일

        .section-text,
        .closing-text {
          font-size: 15px;
          line-height: 26px;
        }

        .signature {
          font-size: 15px;
          line-height: 20px;
        }
      }
    }
  }

  // 모바일 450px 이하
  @media (max-width: 450px) {
    .greetings-content {
      padding: 24px 0 0;
      gap: 20px;

      .greeting-section {
        gap: 16px;

        .text-container {
          gap: 14px;
          padding: 0 20px;  // 좌우 20px 유지

          .main-title {
            font-size: 18px;
            line-height: 28px;
          }

          .sub-title {
            font-size: 16px;
            line-height: 24px;
          }

          .section-text {
            font-size: 14px;
            line-height: 24px;
          }
        }
      }

      .greeting-closing {
        gap: 14px;
        padding: 0 20px;  // 좌우 20px 유지

        .section-text,
        .closing-text {
          font-size: 14px;
          line-height: 24px;
        }

        .signature {
          font-size: 14px;
          line-height: 18px;
        }
      }
    }
  }
}
</style>
